import LogoCurrency_MYR from "assets/images/dollar.png";
import { TypeListCollection } from "components/ui/ListProvider/type";

export const LIST_CURRENCY: TypeListCollection[] = [
  {
    name: "All",
    id: "all"
  },
  {
    name: "BDT",
    id: "myr",
    image: LogoCurrency_MYR
  }
];
